import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Field } from 'formik';
import * as _ from 'lodash';
import i18n from "../../i18n";
import { radiosComponent } from '../../forms/customInput';
import * as rk from '../../localization/resourceKeys';
import { withTranslation } from 'react-i18next';
import BannerNotification from '../../banner/bannerNotification';
import './experianForm.css';
import RetryScreen from './RetryScreen';
import PropTypes from "prop-types";

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

const ExperianForm = (props) => {
  const isProtectionServices = props?.stateSelector?.brandAffiliation === i18n.t(rk.BRANDS_OPTION_VWD_APP_DER);
  const isNetworkError = !_.isEmpty(props.networkError);
  
  const [errorText, setErrorText] = useState();
  const [hideOnRetryScreen, setHideOnRetryScreen] = useState(false);
  useEffect(() => {
    if(props.networkError?.error) {
      const { error } = props.networkError;
      if (isProtectionServices) {
        setHideOnRetryScreen(true);
        if (error.isExperianVerified === false || error.IsExperianVerified === false) {
          setErrorText(i18n.t(rk.EXPERIAN_FORM.API_VERIFY_ERROR));
        } else if (error.isUserVerified === false || error.IsUserVerified === false) {
          setErrorText(i18n.t(rk.ERROR_USER_NOT_FOUND));
        } else {
          setErrorText(i18n.t(rk.ERROR_API_FAIL));
        }
      } else {
        setHideOnRetryScreen(false);
        setErrorText(i18n.t(rk.ERROR_API_FAIL));
      }
    }
  }, [props.networkError, isProtectionServices]);

  const renderNetworkError = () => {
    return isProtectionServices?
      <RetryScreen error={errorText} />
      : <BannerNotification notificationStyle='error'>
        {errorText}
      </BannerNotification>;
  }

  return (
    <form className='experian-form'>
      {!hideOnRetryScreen && <>
        {isProtectionServices ? props.requestForm.step?.selectedFlow === "check" ? (
          <p>{i18n.t(rk.EXPERIAN_FORM.PROTECTION_SERVICES_CONTENT_CHECK)}</p>
        ) : (<p>{i18n.t(rk.EXPERIAN_FORM.PROTECTION_SERVICES_CONTENT_SUBMIT)}</p>) : (
          <>
            <p>{i18n.t(rk.EXPERIAN_FORM.CONTENT1)}</p>
            <p>
              {i18n.t(rk.EXPERIAN_FORM.CONTENT2)}
              <a className='bluetext' href="https://privacy.vwgoa.com">{i18n.t(rk.EXPERIAN_FORM.CONTENT3)}</a>
            </p>
          </>
        )}
      </>}
      {isNetworkError && renderNetworkError()}
      {!hideOnRetryScreen && <>
        <div className="c-form-field c-form-field--static">
          {props.questions.map((item, index) => {
            const { id, options, question } = item;
            return (
              <React.Fragment key={index}>
                <div className="c-form-field__label">
                  {index + 1}. {question}
                </div>
                <div className='c-form-field__box'>
                  <fieldset>
                    <div className='radio-option'>
                      {options.map((opt, optindex) => {
                        return (
                          <Field
                            key={id + '_option_' + optindex}
                            id={opt.value.replace(/ /g, '_') + index}
                            customName={id}
                            radioText={opt.value}
                            onClick={() => { props.setFieldValue(id, optindex + 1) }}
                            isChecked={props.values[id] === optindex + 1}
                            component={radiosComponent}
                          />
                        )
                      })}
                    </div>
                  </fieldset>
                </div>
              </React.Fragment>
            )
          })}
        </div>
        <div className='u-1/1 center-div'>
          <button
            className="c-btn"
            onClick={(evt) => { scrollToTop(); props.handleSubmit(evt); }}
            disabled={!props.isValid}
          >
            <span className="c-btn__text">
              {i18n.t(rk.BUTTON.CONTINUE)}
            </span>
          </button>
        </div>
      </>}
    </form>
  )
}

ExperianForm.propTypes = {
  stateSelector: PropTypes.object,
  brandAffiliation: PropTypes.string,
  networkError: {
    error: PropTypes.object,
    isExperianVerified: PropTypes.bool,
    isUserVerified: PropTypes.bool,
  },
  requestForm: {
    step: {
      selectedFlow: PropTypes.string,
    },
  },
  questions: PropTypes.array,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  isValid: PropTypes.bool,  
};


const mapStateToProps = (state) => ({
  stateSelector: state.stateSelector,
  requestForm: state.requestForm,
});

export default connect(mapStateToProps)(withTranslation()(ExperianForm));